import { useContractWrite, usePrepareContractWrite } from "wagmi"
import { erc721FactoryABI } from "@/util/typechain"
import { BigNumber } from "ethers"

import { useAnalytics } from "hooks/useAnalytics"
import { getChainId } from "@/util/crypto"
import { CreateNewCollectibleData } from "@/types/highlights"
import { useSelector } from "react-redux"
import { selectCurrentNote } from "features/noteSlice"
import { useEffect, useState } from "react"
import { COLLECTIBLE_DATA } from "@/util/crypto"
import { zeroAddress } from "viem"
import { selectBlog } from "features/blogSlice"
import { useGetMintTotalCost } from "hooks/collectibles/useGetMintFee"
import { useReaderReferrer } from "hooks/useReferrer"

export default function useCreateAndCollectHighlight(
  props: CreateNewCollectibleData
) {
  const { track } = useAnalytics()
  const note = useSelector(selectCurrentNote)
  const blog = useSelector(selectBlog)

  const [position, setPosition] = useState<typeof props.position>(
    props.position
  )

  // Need to fetch this from the blog and NOT the cookie.
  const creatorReferrer = blog?.user?.referrerWalletAddress || zeroAddress
  const minterReferrer = useReaderReferrer(blog.id) || zeroAddress

  const { totalCost, error: costError } = useGetMintTotalCost({
    chain: props.chain,
    collectibleCostWei: props.costWei,
  })

  const mintData: any = [
    props.name,
    props.symbol,
    props.ownerAddress,
    props.minterAddress,
    creatorReferrer,
    props.supply,
    props.costWei,
  ]

  const noteId = note?.id || ""
  const from = BigNumber.from(position.from)
  const to = BigNumber.from(position.to)

  const { config, error: prepareError } = usePrepareContractWrite({
    address: COLLECTIBLE_DATA[props.chain].contractAddress,
    abi: erc721FactoryABI,
    functionName: "createAndMint",
    chainId: getChainId(props.chain),
    args: [mintData, minterReferrer, noteId, from, to],

    overrides: {
      value: BigNumber.from(totalCost || 0),

      //maxFeePerGas: feeData?.maxFeePerGas || undefined,
      //gasLimit: BigNumber.from(1000000000000),
      //gasPrice: BigNumber.from(1000000000000),
    }, // Need to pass this in as eth
    //overrides: { value: utils.parseEther(props.costEth.toString()) }, // Need to pass this in as eth
  })

  const error = prepareError || costError

  console.log("usePrepareContractWrite error", error, config)

  const { write, data, isLoading, isSuccess } = useContractWrite(config)

  useEffect(() => {
    if (!error) return

    console.log("NFT already exists", error)

    if (error?.message?.includes("NFT already exists")) {
      console.log("NFT already exists error!", error)

      // This is a very hacky fix. See https://linear.app/paragraph-xyz/issue/PAR-2469/error-collecting-nft-execution-reverted-[factory]-nft-already-exists
      // for explanation why.
      setPosition({ from: 1, to: 1 })
    }

    track("collectible create and collect error", {
      highlight: props,
      error,
    })
  }, [error])

  const buy = () => {
    track("collectible create and mint triggered", {
      ...props,
    })
    write?.()
  }

  return { buy, data, error, isLoading, isSuccess }
}
